import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Switch, useTheme } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, Tab } from "@material-ui/core";
import * as Icons from "react-bootstrap-icons";
import PatternsGroup from "./components/PatternGroup";
import Glass from "./components/Glass";
import Projects from "./components/Projects";
import { read } from "Helpers/LocalStorage";
import MuiButton from "Components/MuiButton/MuiButton";

export default function ShopSettings() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [activatedShop, setActivatedShop] = useState(false);
  const [tab, setTab] = useState("patternsGroup");
  const [active, setActive] = useState(false);

  const handleChange = (event, newTab) => {
    setTab(newTab);
  };

  const switchChange = async (e) => {
    setActivatedShop(e.target.checked);
  };

  useEffect(() => {
    setActive(
      (read("settingShopTemplate") && read("settingShopTemplate").accessShow) ||
        (read("settingShopGlass") && read("settingShopGlass").accessShow) ||
        (read("settingShopProject") && read("settingShopProject").accessShow),
    );
  }, []);

  const onClick = () => {
    window.open("https://fdpco.ir/contact/", "_blank");
  };

  return (
    <>
      {active ? (
        <Fragment>
          <BackDropLoading loading={loading} />

          <div className="page-top-title-button my-4">
            <PageTitle title={<Translator id={"shopSettings"} />} />
          </div>
          {/* --------- WITH SWITCH BUTTON --------- */}
          {/* <div
            className={`page-top-title-button my-3 ${
              direction === "rtl" ? "text-right" : "text-left"
            }`}
          >
            <PageTitle title={<Translator id="shopSettings" />} />
            <div className="top-buttons">
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    className={`switcher ${direction}`}
                    checked={activatedShop}
                    onChange={switchChange}
                  />
                }
                label={
                  <span>{`${t("shopPanel")} ${
                    activatedShop ? t("active") : t("disable")
                  }`}</span>
                }
                className="two-step-login"
              />
            </div>
          </div> */}
          {/* --------- WITH SWITCH BUTTON --------- */}
          <TabContext value={tab}>
            <Box>
              <TabList onChange={handleChange} variant="scrollable">
                <Tab
                  icon={<Icons.Collection />}
                  label={t("patternsGroup")}
                  value="patternsGroup"
                  disabled={!read("settingShopTemplate")}
                  hidden={!read("settingShopTemplate")}
                />
                {/* --------- DEACTIVATED GLASS TAB --------- */}
                {/* <Tab
                  icon={<Icons.BorderAll />}
                  label={t("glass")}
                  value="glass"
                  disabled={!read("settingShopGlass")}
                  hidden={!read("settingShopGlass")}
                /> */}
                {/* --------- DEACTIVATED GLASS TAB --------- */}
                <Tab
                  icon={<Icons.Layers />}
                  label={t("projects")}
                  value="projects"
                  disabled={!read("settingShopProject")}
                  hidden={!read("settingShopProject")}
                />
              </TabList>
            </Box>
            <TabPanel value="patternsGroup" className="py-3 px-2 m-0">
              <MuiPaper>
                <PatternsGroup />
              </MuiPaper>
            </TabPanel>
            <TabPanel value="glass" className="py-3 px-2 m-0">
              <MuiPaper>
                <Glass />
              </MuiPaper>
            </TabPanel>
            <TabPanel value="projects" className="py-3 px-2 m-0">
              <Projects />
            </TabPanel>
          </TabContext>
        </Fragment>
      ) : (
        <div className="no-shop-activated">
          <p>{t("shopNotActivated")}</p>
          <MuiButton
            color="primary"
            title={t("get_active")}
            onClick={onClick}
            fullwidthOnSm
          />
        </div>
      )}
    </>
  );
}
